import './src/global.css';

function detectTrafficSource(referrer) {
  if (!referrer) return '';
  try {
    const d = new URL(referrer).hostname.toLowerCase();
    if (d.includes('google.'))      return 'Google';
    if (d.includes('bing.'))        return 'Bing';
    if (d.includes('yahoo.'))       return 'Yahoo';
    if (d.includes('duckduckgo.'))  return 'DuckDuckGo';
    if (d.includes('baidu.'))       return 'Baidu';
    if (d.includes('yandex.'))      return 'Yandex';
    if (d.includes('facebook.'))    return 'Facebook';
    if (d.includes('instagram.'))   return 'Instagram';
    if (d.includes('twitter.') || d.includes('x.com')) return 'Twitter/X';
    if (d.includes('linkedin.'))    return 'LinkedIn';
    if (d.includes('youtube.'))     return 'YouTube';
    if (d.includes('tiktok.'))      return 'TikTok';
    if (d.includes('pinterest.'))   return 'Pinterest';
    if (d.includes('snapchat.'))    return 'Snapchat';
    if (d.includes('reddit.'))      return 'Reddit';
    if (d.includes('tripadvisor.')) return 'TripAdvisor';
    if (d.includes('booking.'))     return 'Booking.com';
    if (d.includes('expedia.'))     return 'Expedia';
    if (d.includes('agoda.'))       return 'Agoda';
    return d;
  } catch { return ''; }
}

function detectOrganicSource(referrer) {
  if (!referrer) return '';
  try {
    const d = new URL(referrer).hostname.toLowerCase();
    if (d.includes('google.') || d.includes('bing.') || d.includes('yahoo.') ||
        d.includes('duckduckgo.') || d.includes('baidu.') || d.includes('yandex.'))
      return 'Search Engine';
    if (d.includes('facebook.') || d.includes('instagram.') || d.includes('twitter.') ||
        d.includes('x.com') || d.includes('linkedin.') || d.includes('youtube.') ||
        d.includes('tiktok.') || d.includes('pinterest.') || d.includes('snapchat.'))
      return 'Social Media';
    if (d.includes('tripadvisor.') || d.includes('booking.') ||
        d.includes('expedia.') || d.includes('agoda.'))
      return 'Travel Site';
    if (d.includes('reddit.')) return 'Forum/Community';
    return 'Direct';
  } catch { return ''; }
}

export const onClientEntry = () => {
  document.querySelector('body').style.overflow = 'hidden';
  document.getElementById('loader-wrapper').style.display = 'block';
};

function captureAttribution(search) {
  const params = new URLSearchParams(search || '');

  const utmSource     = params.get('utm_source')     || '';
  const utmMedium     = params.get('utm_medium')     || '';
  const utmCampaign   = params.get('utm_campaign')   || '';
  const utmTerm       = params.get('utm_term')       || '';
  const utmContent    = params.get('utm_content')    || '';
  const gclid         = params.get('gclid')          || '';
  const trafficSource = params.get('traffic_source') || '';
  const organic       = params.get('organic')        || '';
  const referrer      = params.get('referrer')       || '';

  // Only write if the param is present — don't overwrite a previously captured value with ''
  if (utmSource)     sessionStorage.setItem('utm_source',     utmSource);
  if (utmMedium)     sessionStorage.setItem('utm_medium',     utmMedium);
  if (utmCampaign)   sessionStorage.setItem('utm_campaign',   utmCampaign);
  if (utmTerm)       sessionStorage.setItem('utm_term',       utmTerm);
  if (utmContent)    sessionStorage.setItem('utm_content',    utmContent);
  if (gclid)         sessionStorage.setItem('gclid',          gclid);
  if (trafficSource) sessionStorage.setItem('traffic_source', trafficSource);
  if (organic)       sessionStorage.setItem('organic',        organic);
  if (referrer)      sessionStorage.setItem('referrer',       referrer);

  // Auto-detect traffic source from UTM source if not explicitly set
  if (!trafficSource && utmSource) {
    sessionStorage.setItem('traffic_source', utmSource.charAt(0).toUpperCase() + utmSource.slice(1));
  }

  // gclid implies Google / CPC — auto-populate if not already set
  if (gclid) {
    if (!sessionStorage.getItem('traffic_source')) sessionStorage.setItem('traffic_source', 'Google');
    if (!sessionStorage.getItem('organic'))        sessionStorage.setItem('organic', 'Search Engine');
  }

  // Auto-detect organic source from UTM medium
  if (!organic && utmMedium) {
    const mediumMap = {
      organic: 'Search Engine', cpc: 'Search Engine', ppc: 'Search Engine',
      social: 'Social Media', facebook: 'Social Media', instagram: 'Social Media',
      twitter: 'Social Media', linkedin: 'Social Media', youtube: 'Social Media',
      tiktok: 'Social Media', pinterest: 'Social Media', snapchat: 'Social Media',
      email: 'Email', referral: 'Referral', display: 'Display', banner: 'Display',
    };
    const derived = mediumMap[utmMedium.toLowerCase()]
      || utmMedium.charAt(0).toUpperCase() + utmMedium.slice(1);
    sessionStorage.setItem('organic', derived);
  }
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  document.querySelector('.loader-wrapper__inner').style.opacity = '0';
  setTimeout(() => {
    document.getElementById('loader-wrapper').style.display = 'none';
    document.querySelector('body').style.overflow = 'auto';
  }, 400);

  if (!location.state) {
    location.state = {};
  }
  location.state.referrer = document.referrer;

  if (prevLocation) {
    sessionStorage.setItem('previous_page', prevLocation.pathname);
  }

  // Capture UTMs/gclid on every SPA navigation that carries them
  if (location.search) {
    captureAttribution(location.search);
  }
};

export const onInitialClientRender = () => {
  // Capture UTMs/gclid on hard page loads (direct URL or browser refresh)
  captureAttribution(window.location.search);

  // Capture external document referrer and auto-detect source
  const documentReferrer = document.referrer || '';
  if (documentReferrer && !documentReferrer.startsWith(window.location.origin)) {
    sessionStorage.setItem('document_referrer', documentReferrer);
    const detectedTraffic = detectTrafficSource(documentReferrer);
    const detectedOrganic = detectOrganicSource(documentReferrer);
    if (!sessionStorage.getItem('traffic_source') && detectedTraffic)
      sessionStorage.setItem('traffic_source', detectedTraffic);
    if (!sessionStorage.getItem('organic') && detectedOrganic)
      sessionStorage.setItem('organic', detectedOrganic);
  }
};
